<template>
    <div class="carousel">
        <transition-group tag="ul" class="slide" name="imgFade">
            <li
                class="carousel-link"
                v-for="(banner, index) in banners"
                :key="'carousel' + index"
                v-show="index === activeIndex"
            >
                <img :src="banner.logo" @click="openDetail(banner)" />
            </li>
        </transition-group>
        <!-- <ul class="carousel-control" :style="{ width: banners.length * 21 + 'px' }">
            <li
                class="carousel-control__item"
                v-for="(banner, index) in banners"
                :key="index"
                :class="{ active: index === activeIndex }"
                @click="change(index)"
            ></li>
        </ul> -->
        <i :class="`el-icon-arrow-left ${activeIndex === 0 ? '' : ''}`" @click="handleClickLeft"></i>
        <i :class="`el-icon-arrow-right ${activeIndex === banners.length - 1 ? '' : ''}`" @click="handleClickRight"></i>
    </div>
</template>

<script>
import { openWindow } from '@/utils/utils';
import { getBanner } from '@/api/home';

export default {
    name: 'Carousel',
    data: () => ({
        timer: null,
        activeIndex: 0,
        banners: [],
    }),
    watch: {
        activeIndex() {
            // this.$nextTick(() => {
            //     this.file = this.detail.fileList[this.activeIndex];
            //     const parentWidth = this.$refs.$file_moved.clientWidth;
            //     const subWidth = this.$refs.$file_moved_item[0].clientWidth;
            //     const perLineNum = Math.floor(parentWidth  / subWidth);

            //     if (this.activeIndex > perLineNum - 2) {
            //     const dist = this.activeIndex - perLineNum + 1;
            //     this.$refs.$file_moved_fit.style.left = `-${dist * subWidth}px`;
            //     } 
            // });
        }
    },
    mounted() {
        this.getBanner();
    },
    beforeDestroy() {
        this.stop();
    },
    methods: {
        /**
         * 点击左翻
         */
        handleClickLeft() {
            if (this.activeIndex === 0) {
                // this.$message.warning('不能再往左翻了哦~');
                this.activeIndex = this.banners.length - 1;
                return;
            }
            this.activeIndex -- ;
        },
        /**
         * 点击右翻
         */
        handleClickRight() {
            if (this.activeIndex === this.banners.length - 1) {
                // this.$message.warning('不能再往右翻了哦~');
                this.activeIndex = 0;
                return;
            }
            this.activeIndex ++ ;
        },
        async getBanner() {
            try {
                const { code, data } = await getBanner();
                if (code === 0) {
                    this.banners = data;
                    this.play();
                }
            } catch (e) {
                throw e;
            }
        },
        play() {
            this.timer = setInterval(() => {
                this.autoPlay();
            }, 5000);
        },
        stop() {
            clearInterval(this.timer);
            this.timer = null;
        },
        change(index) {
            this.activeIndex = index;
        },
        autoPlay() {
            this.activeIndex++;
            if (this.activeIndex > this.banners.length - 1) {
                this.activeIndex = 0;
            }
        },
        openDetail(item) {
            // 平台内部链接
            if (item.isInside === 1) {
                let url;
                switch (item.type) {
                    case 0:
                        url = '/#/experience/detail/';
                        break;
                    case 1:
                        url = '/#/works/detail/';
                        break;
                    case 2:
                        url = '/#/tool/detail/';
                        break;
                    default:
                        break;
                }
                if (url) {
                    openWindow(url + item.contentId);
                }
            } else if (item.isInside === 0 && item.url) {
                openWindow(item.url);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.carousel {
    position: relative;
    height: 400px;
    border-radius: 8px;
    overflow: hidden;

    .slide {
        width: 1600px;
        height: 400px;
    }

    &-link {
        position: absolute;
        top: 0;
        left: 0;
        width: 1600px;
        height: 400px;
        cursor: pointer;

        img {
            display: block;
            margin: 0 auto;
            width: 1600px;
            height: 400px;
            border-radius: 8px;
        }
    }

    &-control {
        position: absolute;
        left: 30px;
        bottom: 20px;
        display: flex;
        justify-content: space-between;
        width: 63px;
        height: 6px;

        &__item {
            width: 17px;
            height: 6px;
            background: rgba(251, 251, 251, 0.3);
            border-radius: 8px;
            cursor: pointer;

            &.active {
                background: rgba(255, 255, 255, 1);
            }
        }
    }
    [class*="el-icon-"] {
        display: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 10px;
        border-radius: 50%;
        background-color: rgba(124, 124, 124, .7);
        font-size: 20px;
        color: #fff;
        cursor: pointer;
        &:hover {
            opacity: 0.9;
        }
        &.disabled {
            opacity: 0.3;
        }
    }
    .el-icon-arrow-left {
        left: 40px;
    }
    .el-icon-arrow-right {
        right: 40px;
    }
    &:hover {
        [class*="el-icon-"] {
            display: block;
        }
    }
}

// 小屏
@include mq($small) {
    .carousel {
        height: 295.312px;

        .slide {
            width: 1200px;
            height: 295.312px;
        }

        &-link {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
// 小屏
@include mq($smaller) {
    .carousel {

        .slide {
            width: unset;
            height: 295.312px;
        }
    }
}
.imgFade-enter-active,
.imgFade-leave-active {
    transition: opacity 0.7s;
}

.imgFade-enter,
.imgFade-leave-active {
    opacity: 0;
}
</style>
